export default "__VITE_ASSET__3586c242__"